<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-6 text-center">

            <h3> Project UrbanTree</h3>
        </div>
        <div class="col-sm-3 text-right">
            <span>Follow: 
            </span>
            <mat-icon style="transform: translate(10px, 5px);">facebook</mat-icon>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-sm-4">
            Net Present Value: <span style="padding: 2px;">$110,500 (5 years)</span>
        </div>
        <div class="col-sm-4">
            Location: <span style="padding: 2px;">New York</span>
        </div>
        <div class="col-sm-4 text-right">
            <a style="color:rgb(21, 21, 204)">Contribute</a>
        </div>
    </div>
    <br>
    <div class="row" style="min-height: 350px; align-content: center;">
        <div class="col-sm-6">
            <img src="../../../assets/nft.png" style="width: 90%;">
        </div>
        <div class="col-sm-6" style="align-self: center;">
            <div [formGroup]="inputForm">
                <div class="form-group">
                    <label for="name">Information: </label>
                    <p> Using urban farming to provide modular urban farms. By dramatically reducing operating costs, we aim to deliver organic and fresh produce directly to customers.</p>
                    <input formControlName="value" name="value" type="text" class="form-control" id="name">
                </div>
                <button type="submit" (click)="mintInfo(inputForm)" class="btn btn-primary">Tokenise this</button>

            </div>
        </div>
    </div>

</div>